import React from 'react'
import styled from 'styled-components'
import Button from 'modules/common/components/button/Button'
import Icon from 'modules/common/components/icon/Icon'
import { ICONS } from 'modules/common/components/icon/Icons'

const ButtonIcon = styled(Icon)`
    margin-right: 10px;
`

const MButton = styled(Button)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`

const MapButton = ({
  text = '',
  onClick = () => {},
  className = '',
}) => {
  return (
    <MButton
      className={className}
      onClick={onClick}
    >
      <ButtonIcon
        icon={ICONS.MAP}
        width="20px"
        height="18px"
      />
      {text}
    </MButton>
  );
}

export default MapButton



// WEBPACK FOOTER //
// ./src/modules/search/components/MapButton.js